export const exists = (value) => {
  return value !== null && value !== undefined;
};
